import actionTypes from './../constants/actionTypes';

const initialState = {
    listing: {},
    saveResponse: {},
    getTrackingResponse: {},
};

export const trackingReducer = (state = initialState, action) => {
    try {
        const { type, payload, status } = action;
        switch (type) {
            case actionTypes.TRACKING.TRACKING_LIST: {
                return {
                    ...state,
                    listing: payload
                }
            }
            case actionTypes.TRACKING.SAVE_TRACKING: {
                return {
                    ...state,
                    saveResponse: payload
                }
            }
            case actionTypes.TRACKING.GET_TRACKING: {
                return {
                    ...state,
                    getTrackingResponse: payload
                }
            }
        }
        return state;
    } catch (error) {
        return state;
    }
}
export default trackingReducer;
